import { render, staticRenderFns } from "./numericalCode.vue?vue&type=template&id=38377346&scoped=true&"
import script from "./numericalCode.vue?vue&type=script&lang=js&"
export * from "./numericalCode.vue?vue&type=script&lang=js&"
import style0 from "./numericalCode.vue?vue&type=style&index=0&id=38377346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38377346",
  null
  
)

export default component.exports